import React from 'react';
import styled from 'styled-components';

interface Props {
  option: string;
  children: React.ReactNode;
  onClose: () => void;
}

const titleMap: Record<string, string> = {
  type: '경매/공매',
  saleDate: '매각기일',
  approvalDate: '사용승인',
  appraisalPrice: '감정가',
  buildingArea: '건물면적',
  landArea: '토지면적',
  region: '지역',
  minPrice: '최저가',
  caseNumber: '연도/사건번호',
  court: '법원 선택',
  totalCategory: '물건종류',
  progressStatus: '진행단계',
  bidno: '유찰횟수',
  address: '상세주소',
};

function SaveOptionModal({ option, children, onClose }: Props) {
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <TitleBox>
          {/* <Spacer /> */}
          <img
            src="/assets/images/arrow/arrow-right-gray.svg"
            alt=""
            height={24}
            onClick={onClose}
          />
          <Title>{titleMap[option]}</Title>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            width={24}
            onClick={onClose}
          />
        </TitleBox>
        <Content>{children}</Content>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default SaveOptionModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: 640px;

  display: flex;
  flex-direction: column;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  img {
    transform: rotate(-180deg);
  }
`;
const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  flex: 1;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
`;
